import React from 'react';
import './GroupAction.css';
import logoba from '../../../../assets/img/logo-ba.png';

let GroupAction = props => {
    return (
        <div className="group-login loggedin">
            <img src={logoba} alt="logo black and white"/>
            <p>Enter your results<br/>by clicking the button</p>
            <button onClick={props.enterResults}>Click to enter your results</button>
        </div>
    );
};

export default GroupAction;


// WEBPACK FOOTER //
// ./src/components/Groups/Group/GroupAction/GroupAction.jsx